import { render, staticRenderFns } from "./applyText.vue?vue&type=template&id=33464a29&scoped=true&"
import script from "./applyText.vue?vue&type=script&lang=js&"
export * from "./applyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33464a29",
  null
  
)

export default component.exports